import React, { useEffect, useMemo, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { getInquiryBidsSummaryData, getTenantQuotationSummeryById, postTransferStatusData } from "../../store/Sales/actions";
import { formatModifyDate, getInternalRoute } from "../../components/Common/CommonLogic";
import { QueriesColVal } from "../Sales/partials/SalesCol";
import { accept, eye_icon, reject, upload_icon } from "../../assets/images";
import FilterSalesInquiryComp from "../Sales/partials/FilterSalesInquiryComp";
import BackButton from "../../components/GlobalComponent/BackButton";
import ViewBidsTable from "./component/ViewBidsTable";
import Page from "../../components/GlobalComponent/PageComponent";
import { BID_ACCEPTED } from "../Dashboard/Partials/initialData";
import QuotationModalComp from "../InstantRate/partials/QuotationModalComp";
import ButtonGroup from "../../components/GlobalComponent/ButtonGroupComponent";
import PriceBreakDownModal from "../../components/GlobalComponent/PriceBreakDownModal";
import { RESET_SHIPMENT_FORM_DATA, SMART_QUOTATION_VALUE_UPDATE, UPDATE_SEARCH_INSTANT_RATE_DATA } from "../../store/InstantRate/actionType";
import { BOOKINGS_STATUS_INIT } from "../../store/Sales/actiontype";
import { Input } from "reactstrap";
import { showErrorToast } from "../../components/Common/CustomToast";

// Utility function to check if a status is in the approved list
const hasApprovedStatus = (status) => {
    return ['customer approved', 'booking_requested', 'booking accepted', 'booking requested']
        .includes(status?.toLowerCase());
};

const ViewBids = () => {
    document.title = "View Bids || Navigating Freight Costs with Precision||Ultimate Rate Management platform"

    const { inquiry_data_loader, ViewBidsSummaryData } = useSelector((state) => state?.sales);
    const { postStatus } = useSelector((state) => state?.quotation)
    const [isRight, setIsRight] = useState(false);
    const { status_master } = useSelector((state) => state.globalReducer);
    const [currentPage, setCurrentPage] = useState(0);
    const navigate = useNavigate();
    const navigateState = useLocation();
    const tableRef = useRef(null);
    const [inquiryId, setInquiryId] = useState(0);
    const [quotationType, setQuotationType] = useState(false);
    const [modal, setModal] = useState(false);
    const [modalType, setModalType] = useState(false);
    const [previewModal, setPreviewModal] = useState(false);
    const [customerStatus, setCustomerStatus] = useState('');
    const [isPriceBreakDownModalOpen, setIsPriceBreakDownModalOpen] = useState(false);
    const [quotationData, setQuotationData] = useState(null);
    const [inquiryData, setInquiryData] = useState({});
    const [inquiriesType, setInquiriesType] = useState();
    const [quotationId, setQuotationId] = useState("");
    const [selectedRows, setSelectedRows] = useState([]);



    const dispatch = useDispatch();
    const inputArr = {
        org_port: '',
        dest_port: '',
        status: '',
        valid_from: '',
        valid_to: '',
        customer: '',
        sales_employee: '',
        isExcelGenerated: false
    }
    const [filterDetails, setfilterDetails] = useState(inputArr);

    useEffect(() => {
        dispatch({ type: SMART_QUOTATION_VALUE_UPDATE, payload: { quote_currency: {} } });
        console.log(navigateState?.state?.data, "navigateState?.state?.data");

        setQuotationData(navigateState?.state?.data);
        setInquiryData(navigateState?.state?.data);
        setInquiriesType(navigateState?.state?.data?.rateType)
        const inquiryId = navigateState?.state?.data?.inquiryId;
        
        if (inquiryId) {
            setInquiryId(inquiryId);
        }
        
        dispatch({
            type: SMART_QUOTATION_VALUE_UPDATE,
            payload: { quote_currency: { value: 'US DOLLAR', label: 'USD', currencyCode: 'USD', id: 3, version: 0 } },
        });
    }, [navigateState]);

    console.log(navigateState?.state?.data, "navigateState?.state?.data");
    

    const toggleRightCanvas = () => {
        setIsRight(!isRight);
    };

    const constructUrl = (page, filters) => {
        let url = `?page=${page}&size=10&inquiryId=${inquiryId}`;
        return url; // Remove trailing '&'
    };

    const applyFilterHandler = () => {
        setIsRight(false);
        filterDetails.isExcelGenerated = false;
        let url = constructUrl(currentPage, filterDetails);
        dispatch(getInquiryBidsSummaryData(url));
    };

    const clearValueHandler = () => {
        setfilterDetails(inputArr);
        let url = constructUrl(currentPage, {});
        dispatch(getInquiryBidsSummaryData(url));
    };
    useEffect(() => {
        if (inquiryId !== 0 && inquiryId !== undefined) {
            let url = constructUrl(currentPage, {});
            dispatch(getInquiryBidsSummaryData(url));
        }
    }, [currentPage, inquiryId]);

    const downLoadExcelReport = () => {
        filterDetails.isExcelGenerated = true;
        let url = constructUrl(currentPage, filterDetails);
        dispatch(getInquiryBidsSummaryData(url));
    }

    const viewPopupHandler = (data, type) => {
        setModal(true);
        setModalType(type);
    }

    function QuoteModalHandler(type, data = {}) {
        setInquiriesType(navigateState?.state?.data?.rateType);
        setQuotationId(data?.id);
        priceBreakDownModalHandler();
        dispatch(getTenantQuotationSummeryById(data?.id));

        // if (data?.id === undefined) {
        //     setModal(false);
        // } else {
        //     setQuotationType(type);
        //     
        //     setModal(!modal);
        //     viewPopupHandler("", type)
        // }
    }

    const handleConfirm = (data) => {
        dispatch({ type: RESET_SHIPMENT_FORM_DATA });
        dispatch({ type: BOOKINGS_STATUS_INIT });
        if (inquiryData?.rateType === 'AIR') {
            dispatch({
                type: UPDATE_SEARCH_INSTANT_RATE_DATA,
                payload: { name: "quote_currency", item: { label: 'INR', value: 'rupee', currencyCode: "INR", id: 2, version: 0 } }
            });
        } else {
            dispatch({
                type: UPDATE_SEARCH_INSTANT_RATE_DATA,
                payload: { name: "quote_currency", item: { label: 'USD', value: 'dollar', currencyCode: "USD", id: 3, version: 0 } }
            });
        }
        navigate(getInternalRoute("instant-rate-booking"), {
            state: {
                item: inquiryData,
                summaryItem: data,
                instantInquiryId: data?.inquiryId,
                bookingType: inquiryData?.rateType === 'AIR' ? 'air' : 'ocean_fcl',
                bookingFrom: "viewBids",

            },
        });
        console.log(data, "data");
        // const url = '?summeryId=' + data?.id + '&statusId=' + status_master?.find((item) => item?.statusCode === BID_ACCEPTED)?.id + '&inquiryId='+data?.inquiryId;
        // dispatch(postTransferStatusData(url))
        // setTimeout(() => {
        //     //navigate(-1);
        // }, 300)
    };

    useEffect(() => {
        if (postStatus === true) {
            if (inquiryId !== 0 && inquiryId !== undefined) {
                setCustomerStatus("Customer Approved");
                let url = constructUrl(currentPage, {});
                dispatch(getInquiryBidsSummaryData(url));
            }
        }
    }, [postStatus]);

    const handleSelectAll = (isChecked) => {
        if (isChecked) {
            const allIds = ViewBidsSummaryData?.content?.map((item) => item.id) || [];
            setSelectedRows(allIds);
        } else {
            setSelectedRows([]);
        }
    };

    const handleRowSelect = (isChecked, id) => {
        if (isChecked) {
            setSelectedRows((prev) => [...prev, id]);
        } else {
            setSelectedRows((prev) => prev.filter((rowId) => rowId !== id));
        }
    };

    const onClickAssingto = () => {
        if (selectedRows.length > 1) {
            navigate(`/freight/air/compare-rate`, {
                state: {
                    data: selectedRows || '',
                },
            })
        } else {
            showErrorToast("please select at least two quotations to compare.")
        }
    }


    const columns = useMemo(() => [
        {
            Header: (
                <Input
                    type="checkbox"
                    className="custom-checkbox"
                    onChange={(e) => handleSelectAll(e.target.checked)}
                    defaultChecked={
                        ViewBidsSummaryData?.content?.length > 0 &&
                        selectedRows.length === ViewBidsSummaryData?.content?.length
                    }
                />
            ),
            accessor: 'select',
            disableFilters: true,
            disableSortBy: true,
            Cell: ({ row }) => (
                <Input
                    type="checkbox"
                    className="custom-checkbox"
                    defaultChecked={selectedRows.includes(row.original.id)}
                    onChange={(e) => handleRowSelect(e.target.checked, row.original.id)}
                />
            ),
        },
        {
            Header: 'Quotation Dt',
            accessor: 'quotationDate',
            filterable: true,
            disableFilters: true,
            Cell: (cellProps) => {
                return (
                    <span>{formatModifyDate(cellProps.row.original?.quotationDate)}</span>
                )
            }
        },
        {
            Header: 'Quotation Id',
            accessor: 'id',
            filterable: true,
            disableFilters: true,
            Cell: (cellProps) => {
                return <QueriesColVal cellProps={cellProps} />
            }
        },
        {
            Header: 'Ranking',
            accessor: 'quotationRank',
            filterable: true,
            disableFilters: true,
            Cell: (cellProps) => {
                return <QueriesColVal cellProps={cellProps} />
            }
        },
        {
            Header: 'Agent Location',
            accessor: 'cityName',
            filterable: true,
            disableFilters: true,
            Cell: (cellProps) => {
                return <QueriesColVal cellProps={cellProps} />
            }
        },
        {
            Header: 'Bid Breakup',
            accessor: 'bidBreakup',
            filterable: true,
            disableFilters: true,
            Cell: (cellProps) => {
                return <div className="d-flex justify-content-start align-items-start h-100">
                    <img src={eye_icon} alt="Eye" onClick={() => { QuoteModalHandler('viewBids', cellProps.row?.original); }} />
                </div>
            }
        },
        {
            Header: 'Total Bid Amount',
            accessor: 'totalSaleCost',
            filterable: true,
            disableFilters: true,
            Cell: (cellProps) => {
                return <QueriesColVal cellProps={cellProps} />
            }
        },

        {
            Header: 'Action',
            disableFilters: true,
            disableSortBy: true,
            Cell: ({ row }) => {
                const rowId = row.original.id;
                const isDisabled = selectedRows.includes(rowId) || !navigateState?.state?.data?.isExpired || hasApprovedStatus(navigateState?.state?.data?.statusCode?.toLowerCase());
                return (
                    <div className="row justify-content-start">
                        <div className="d-flex justify-content-start gap-2">
                            <ButtonGroup
                                showCancel={false}
                                showSubmit={true}
                                onSubmit={() => handleConfirm(row.original)}
                                submitText="Accept & Book"
                                submitClass="btn btn-primary bid-btn"
                                disabled={isDisabled}
                            />
                        </div>
                    </div>
                );
            },
        },
    ], [selectedRows]);

    const priceBreakDownModalHandler = () => {
        setIsPriceBreakDownModalOpen(!isPriceBreakDownModalOpen);
    };

    return (
        <>
            <Page>
                <BackButton navigate={navigate} />
                <ViewBidsTable
                    tableRef={tableRef}
                    columns={columns}
                    inquiryType={inquiryData?.rateType}
                    data={!!ViewBidsSummaryData.content ? ViewBidsSummaryData.content : []}
                    isGlobalFilter={true}
                    isAddInvoiceList={true}
                    loader={inquiry_data_loader}
                    customPageSize={10}
                    toggleRightCanvas={toggleRightCanvas}
                    downLoadExcelReport={downLoadExcelReport}
                    onClickAssingto={onClickAssingto}
                    component={'inquiry'}
                    setCurrentPage={setCurrentPage}
                    totalPages={ViewBidsSummaryData?.totalPages || 0}
                    totalEntries={ViewBidsSummaryData?.totalElements || 0}
                />
            </Page>
            <FilterSalesInquiryComp isRight={isRight} toggleRightCanvas={toggleRightCanvas} filterDetails={filterDetails} setfilterDetails={setfilterDetails} applyFilterHandler={applyFilterHandler} clearValueHandler={clearValueHandler} />

            {isPriceBreakDownModalOpen && <PriceBreakDownModal quotationId={quotationId} isPriceBreakDownModalOpen={isPriceBreakDownModalOpen} quotationData={quotationData} priceBreakDownModalHandler={priceBreakDownModalHandler} inquiriesType={inquiriesType} />}
        </>
    )
}

export default ViewBids;
